import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PrivateRoute({ children }) {
  const { usuario, carregando } = useAuth();

  if (carregando) return <div style={{ padding: '2rem' }}>Carregando...</div>;
  if (!usuario) return <Navigate to="/login" />;

  return children;
}